import React, { useState, useEffect } from 'react';
import SalesStatisticOne from './child/SalesStatisticOne';
import UsersOverviewOne from './child/UsersOverviewOne';
import LatestRegisteredOne from './child/LatestRegisteredOne';
import UnitCountOne from './child/UnitCountOne';
import UnitCountTwo from './child/UnitCountTwo';
import PortalDisclaimer from './child/PortfolioDisclaimer';

const DashBoardLayerOne = () => {
  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    const accepted = sessionStorage.getItem("indDisclaimerAccepted");
    if (accepted === "true") {
      setIsAccepted(true);
    }
  }, []);

  const handleAccept = () => {
    setIsAccepted(true);
    sessionStorage.setItem("indDisclaimerAccepted", "true");
  };

  if (!isAccepted) {
    return <PortalDisclaimer onAccept={handleAccept} />;
  }

  return (
    <>
      <UnitCountTwo />
      <UnitCountOne />
      <section className="row gy-4 mt-1">
        <SalesStatisticOne />
        <UsersOverviewOne />
        <LatestRegisteredOne />
      </section>
    </>
  );
};

export default DashBoardLayerOne;
